export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (char) {
      const randomValue = (Math.random() * 16) | 0;
      const replacement =
        char === 'x' ? randomValue : (randomValue & 0x3) | 0x8;
      return replacement.toString(16);
    }
  );
}
